module.exports = __webpack_public_path__ + "img/art_tea_in_the_evening.edaebc4b.jpg";